<template>
  <v-container class="col-12">
    <v-card>
      <v-row class="mx-2 mb-4" style="white-space: nowrap">
        <select-project
          v-model="project"
          multiple
          default-value
          style="min-width: 200px; flex: auto; width: auto; max-width: 350px;"
        >
        </select-project>

        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="report-base-filter"
          style="min-width: 150px"
        ></v-select>
        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 140px"
        />

        <v-combobox
          v-model="affiliate"
          :items="affiliates"
          :loading="affiliates.length == 0"
          label="Affiliate"
          style="min-width: 200px"
          class="report-base-filter"
          hide-details
        />
        <v-checkbox
          label="Unsigned"
          v-model="any_aff"
          hide-details
          class="mr-2"
        />

        <v-btn color="info" v-on:click="search" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
        <export :fields="exportFields" without_sg="true" :data="items" :reportName="title" :project="project" />
      </v-row>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :items-per-page="-1"
        show-expand
        single-expand
        item-key="row_key"
        @item-expanded="expandInit"
        hide-default-footer
        class="col-12 pa-0 affiliate_stats-dt"
        fixed-header
      >

        <template v-slot:item.row_num="{ item }">
          <span class="row_num"></span>
        </template>

        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length">
            <v-data-table
              v-if="subItems[item.row_key]"
              :headers="expandHeaders"
              :items="filteredSubItems"
              :loading="subItems[item.row_key].loading"
              :items-per-page="-1"
              hide-default-footer
              class="col-12 pa-0 affiliate_stats-sub-dt"
              fixed-header
              height="300px"
            >

              <template v-slot:body.prepend>
                <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
                  <td
                    v-for="header in expandHeaders"
                    :key="header.text"
                  >
                    <v-select
                      v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                      hide-details
                      dense
                      small
                      multiple
                      clearable
                      persistent-hint
                      single-line
                      class="data-table-finance-filter-select"
                      :items="filters[header.value].values || columnValueList(header.value, item.row_key)"
                      :style="{width: (filters[header.value] || {width: false}).width}"
                      v-model="filters[header.value].data"
                    ></v-select>
                    <v-text-field
                      class="data-table-finance-filter-textfield"
                      v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                      v-model="filters[header.value].data"
                      :style="{width: (filters[header.value] || {width: false}).width}"
                      hide-details
                    ></v-text-field>
                  </td>
                </tr>
              </template>

              <template v-slot:item.login="{ item }">
                <a :href="'/user-management/' + item.account_id " target="_blank">{{ item.login }}</a>
              </template>
              <template v-slot:item.row_num="{ item }">
                <span class="row_num"></span>
              </template>
            </v-data-table>
          </td>
        </template>

        <template v-slot:body.append>
          <template v-if="totalRows">
            <tr v-for="row in totalRows">
              <td
                v-for="header in headers"
                :key="header.text"
              >
                <b v-if="header.value === 'project'">Total</b>
                {{ row[header.value] }}
              </td>
            </tr>
          </template>
          <tr v-if="totalRow">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <b v-if="header.value === 'project'">Total</b>
              {{ totalRow[header.value] }}
            </td>
          </tr>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import { API } from '@/utils/api'
  import { map, get } from 'lodash'
  import moment from 'moment'
  import Vue from 'vue'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    props: { title: {}, defaultParams: { default: () => ({}) } },
    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export')
    },
    data: () => ({
      dateRangeList,

      affiliate: '',

      expanded: false,

      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),

      addedNew: false,
      loading: false,
      headers: [
        { text: '', value: 'data-table-expand', 'class': 'nowrap' },
        // { text: '#', value: 'row_num', sortable: false },
        { text: 'Project', value: 'project' },
        { text: 'Affiliate', value: 'affiliate' },
        { text: 'Currency', value: 'currency' },
        { text: 'Funded', value: 'funded' },
        { text: 'Registrations', value: 'registrations' },

        { text: 'Deposit (EUR)', value: 'deposit_eur', sortable: true },
        { text: 'Reg2dep %', value: 'funded_percent', sortable: true },
        { text: 'Withdraw (EUR)', value: 'withdraw_eur', sortable: true },
        { text: 'Correction (EUR)', value: 'correction_eur', sortable: true },
        { text: 'Bonus Deposit (EUR)', value: 'bonus_deposit_eur', sortable: true },
        { text: 'Bonus Withdraw (EUR)', value: 'bonus_withdraw_eur', sortable: true },
        { text: 'Bet (EUR)', value: 'bet_eur', sortable: true },
        { text: 'Win (EUR)', value: 'win_eur', sortable: true },
        { text: 'FS Win (EUR)', value: 'freespin_win_eur', sortable: true },
        { text: 'GGR (EUR)', value: 'ggr_eur', sortable: true },
        { text: 'NGR (EUR)', value: 'ngr_eur', sortable: true },

        { text: 'Deposit', value: 'deposit', sortable: true },
        { text: 'Withdraw', value: 'withdraw', sortable: true },
        { text: 'Correction', value: 'correction', sortable: true },
        { text: 'Bonus Deposit', value: 'bonus_deposit', sortable: true },
        { text: 'Bonus Withdraw', value: 'bonus_withdraw', sortable: true },
        { text: 'Bet', value: 'bet', sortable: true },
        { text: 'Win', value: 'win', sortable: true },
        { text: 'FS Win', value: 'freespin_win', sortable: true },
        { text: 'GGR', value: 'ggr', sortable: true },
        { text: 'NGR', value: 'ngr', sortable: true },
      ],

      expandHeaders: [
        { text: '#', value: 'row_num', sortable: false },
        { text: 'AccountID', value: 'account_id' },
        { text: 'Affiliate', value: 'affiliate' },
        { text: 'Login', value: 'login' },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Currency', value: 'currency' },
        { text: 'Country', value: 'country' },
        { text: 'Balance', sortable: false, value: 'balance', },

        { text: 'Deposit (EUR)', value: 'deposit_eur', sortable: true },
        { text: 'Withdraw (EUR)', value: 'withdraw_eur', sortable: true },
        { text: 'Correction (EUR)', value: 'correction_eur', sortable: true },
        { text: 'Bonus Deposit (EUR)', value: 'bonus_deposit_eur', sortable: true },
        { text: 'Bonus Withdraw (EUR)', value: 'bonus_withdraw_eur', sortable: true },
        { text: 'Bet (EUR)', value: 'bet_eur', sortable: true },
        { text: 'Win (EUR)', value: 'win_eur', sortable: true },
        { text: 'FS Win (EUR)', value: 'freespin_win_eur', sortable: true },
        { text: 'GGR (EUR)', value: 'ggr_eur', sortable: true },
        { text: 'NGR (EUR)', value: 'ngr_eur', sortable: true },

        { text: 'Deposit', value: 'deposit', sortable: true },
        { text: 'Withdraw', value: 'withdraw', sortable: true },
        { text: 'Correction', value: 'correction', sortable: true },
        { text: 'Bonus Deposit', value: 'bonus_deposit', sortable: true },
        { text: 'Bonus Withdraw', value: 'bonus_withdraw', sortable: true },
        { text: 'Bet', value: 'bet', sortable: true },
        { text: 'Win', value: 'win', sortable: true },
        { text: 'FS Win', value: 'freespin_win', sortable: true },
        { text: 'GGR', value: 'ggr', sortable: true },
        { text: 'NGR', value: 'ngr', sortable: true },
      ],
      filters: {
        project: { data: [], type: 'select' },
        type: { data: [], type: 'select' },
        currency: { data: [], type: 'select', width: '75px' },
        country: { data: [], type: 'select', width: '75px' },
        status: { data: [], type: 'select', width: '75px' },
      },
      chipCount: 3,
      project: [],
      any_aff: true,
      items: [],
      subItems: {},
      affiliates: [],
      paymethods: [],
      gameBrand: [],
      system_brand: [],
      totalRows: [],
      totalRow: false,
    }),

    computed: {
      innerWidth: function () {
        return window.innerWidth
      },

      exportFields: function () {
        return map(this.headers, 'value')
      },

      filteredSubItems: function () {
        let key = this.expanded
        return this.subItems[key].items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes((get(d, f) || ''))
                || (this.filters[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    mounted () {
      this.loadAffiliates()
    },

    methods: {

      expandInit: function (init) {
        if (!init.value) return
        this.expanded = init.item.row_key

        for (let k in this.filters) {
          this.filters[k].data = []
        }

        this.searchExpanded(init.item.affiliate, init.item.currency, init.item.entity_id)
      },
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      loadAffiliates () {
        return API.call('/$v/affiliate/list.json', {}, null, this.project[0]).then(resp => {
          this.affiliates = resp.data
        })
      },

      search () {
        this.loading = true

        setTimeout(() => {
          return API.call('/$v/reports/profit_by_account.json', {
            report_by: 'affiliate',
            from: this.from,
            to: this.to,
            affiliate: this.affiliate,
            any_aff: this.any_aff,
            convert2eur: true,
            by_entities: this.project
          }, null, this.project[0]).then(resp => {
            this.items = resp.data
            this.totalRows = resp.totalRows
            this.totalRow = resp.totalRow
            return resp.data
          }).finally(() => {
            this.loading = false
          })
        }, 500)
      },

      searchExpanded (affiliate, currency, entity_id) {
        let key = this.expanded
        if (!this.subItems[key]) {
          this.subItems[key] = Vue.observable({
            items: [],
            loading: false
          })
        }

        this.subItems[key].loading = true

        return API.call('/$v/reports/profit_by_account.json', {
          report_by: 'player',
          from: this.from,
          to: this.to,
          affiliate: affiliate,
          currency,
          any_aff: this.any_aff,
          convert2eur: true
        }, null, entity_id).then(resp => {
          this.subItems[key].items = resp.data
          this.subItems[key].totalRows = resp.totalRows
          this.subItems[key].totalRow = resp.totalRow
          return resp.data
        }).finally(() => {
          this.subItems[key].loading = false
        })
      },

      columnValueList (val) {
        let key = this.expanded
        return this.subItems[key].items.map(d => d[val])
      }
    },
  }
</script>
